// src/components/studio/StudioNavbar.jsx
import React, { useState, useEffect } from 'react';
import { NavLink, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import Logo from 'assets/Transparent Logo.svg';

export default function StudioNavbar() {
  const { currentUser, logout, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const handleLogout = async () => {
    await logout();
    setIsMobileMenuOpen(false);
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="container header-container">
        
        {/* Brand/Logo Section */}
        <div className="header-brand">
          <Link to="/studio" className="logo-link">
            <img src={Logo} alt="Flytte og Fragttilbud" className="logo" />
            <span> </span><span className="brand-secondary"></span>
          </Link>
        </div>

        {/* DESKTOP NAV */}
        <nav className="desktop-nav">
          {loading ? (
            <div className="auth-buttons">Indlæser...</div>
          ) : currentUser ? (
            <>
              {/* Active Admin Dashboard Link in the Center */}
              <div className="nav-links-left">
                <NavLink to="/studio" className="nav-link active">
                  {currentUser?.role === 'content_moderator' ? 'Indholdsstudie' : 'Admin Dashboard'}
                </NavLink>
              </div>

              {/* User Section on the Right */}
              <div className="nav-user-section">
                <div className="user-profile">
                  <div className="user-avatar">
                    {currentUser.name?.charAt(0) || currentUser.email?.charAt(0) || 'M'}
                  </div>
                  <div className="user-details">
                    <span className="user-name">{currentUser.name || currentUser.email}</span>
                    <span className="user-role">{currentUser?.role === 'admin' ? 'Admin' : 'Moderator'}</span>
                  </div>
                </div>
                <button onClick={handleLogout} className="btn-logout">
                  Log ud
                </button>
              </div>
            </>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="btn btn-outline">Log ind</Link>
            </div>
          )}
        </nav>

        {/* MOBILE NAV BURGER */}
        <div className="mobile-nav-container">
          <button
            className="mobile-nav-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-expanded={isMobileMenuOpen}
            aria-controls="mobile-nav-menu"
          >
            <span /><span /><span />
          </button>

          <nav id="mobile-nav-menu" className={`mobile-nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
            <button
              className="mobile-menu-close"
              onClick={() => setIsMobileMenuOpen(false)}
              aria-label="Luk menu"
            >
              &times;
            </button>

            {loading ? (
              <div className="mobile-links">Indlæser...</div>
            ) : currentUser ? (
              <>
                <div className="mobile-user-info">
                  <div className="user-avatar large">
                    {currentUser.name?.charAt(0) || currentUser.email?.charAt(0) || 'M'}
                  </div>
                  <div>
                    <div className="user-name">{currentUser.name || currentUser.email}</div>
                    <div className="user-role">{currentUser?.role === 'admin' ? 'Admin' : 'Moderator'}</div>
                  </div>
                </div>
                <div className="mobile-links">
                  <NavLink to="/studio" className="nav-link active" onClick={() => setIsMobileMenuOpen(false)}>
                    {currentUser?.role === 'content_moderator' ? 'Indholdsstudie' : 'Admin Dashboard'}
                  </NavLink>
                </div>
                <button onClick={handleLogout} className="btn-logout-mobile">
                  Log ud
                </button>
              </>
            ) : (
              <div className="mobile-links">
                <NavLink to="/login" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>Log ind</NavLink>
              </div>
            )}
          </nav>
        </div>

      </div>
    </header>
  );
}
